export enum CalculateCommissionAmountRoute {
  CalculateCommissionAmount = '/pay-link/calculate-commission',
}
